import React from 'react'
import { Redirect, Route, useRouteMatch } from 'react-router-dom'
import Dashboard from '@/views/app/Stalls/Dashboard'
import History from '@/views/app/Stalls/History'

function StallsRoutes() {
  const { path } = useRouteMatch()

  return (
    <div>
      <Route path={path} exact>
        <Dashboard title="Petis - Parceiros / Baias" />
      </Route>
      <Route path={`${path}/dashboard`} exact>
        <Redirect to={path} />
      </Route>
      <Route path={`${path}/:id(\\d+)/history`} exact>
        <History title="Petis - Parceiros / Baias / Histórico" />
      </Route>
      <Route path={`${path}/:id(\\d+)`} exact>
        <Redirect to={path} />
      </Route>
    </div>
  )
}

export default StallsRoutes
